import React from 'react'

import Success from '../../templates/ContactUs/Success'

const ContactUsSuccessContainer = () =>
  <Success {...this.props} />

export default ContactUsSuccessContainer



// WEBPACK FOOTER //
// ./src/components/pages/ContactUs/Success.container.js